import CounterComponent from "../components/counter";
import LiComponent from "../components/li";
import ProductCartComponent from "../components/product-cart";
import {getProductData} from "../parsing/product";
import {setAddCart} from "../require/set-add-cart";
import {setDeleteCart} from "../require/set-delete-cart";
import {setOptionCart} from "../require/set-option-cart";
import {setReduceCart} from "../require/set-reduce-cart";
import {render, RenderPosition} from "../utils/render";

export default class CartItemsController {
  constructor({items = [], shopInfoData, onDataChange}) {
    this._items = items;
    this._shopInfoData = shopInfoData;
    this._onDataChange = onDataChange;

    this._openedOptions = [];
  }

  render(container) {
    Object.values(this._items).forEach((productData) => {
      const product = getProductData(productData);

      const liItemComponent = new LiComponent({
        className: `cart-page__item`,
      });
      render(container, liItemComponent.getElement(), RenderPosition.BEFOREEND);

      const productCardComponent = new ProductCartComponent({
        className: `cart-page`,
        cityP: this._shopInfoData.town_p,
        data: product,
        // isShowOptions: this._openedOptions.includes(product.itemId),
      });

      this._renderCounter(productCardComponent.getElement().querySelector(`.cart-page__counterWrap`), product.itemId, product.count);

      productCardComponent.setDeleteButtonClickHandler(() => this._onRemoveButtonClickHandler(product.itemId));
      productCardComponent.setOptionChangeHandler((optionId, action) => this._onOptionChangeHandler(product.itemId, optionId, action));
      productCardComponent.setExpandOptionsButtonClickHandler((isShow) => this._onExpandOptionsButtonClickHandler(product.itemId, isShow));
      productCardComponent.setExpandGiftsButtonClickHandler((isShow) => this._onExpandGiftsButtonClickHandler(product.itemId, isShow));

      render(liItemComponent.getElement(), productCardComponent.getElement(), RenderPosition.BEFOREEND);
    });
  }

  _renderCounter(container, itemId, count) {
    if (!container) {
      return;
    }

    const counterComponent = new CounterComponent({
      className: `cart-page`,
      count,
    });

    counterComponent.setAddButtonClickHandler(() => this._onAddButtonClickHandler(itemId));
    counterComponent.setDeleteButtonClickHandler(() => this._onDeleteButtonClickHandler(itemId));

    render(container, counterComponent.getElement(), RenderPosition.BEFOREEND);
  }

  _onRemoveButtonClickHandler(itemId) {
    setDeleteCart(itemId, (response) => {
      this._onDataChange(response);
    });
  }

  _onAddButtonClickHandler(itemId) {
    setAddCart(itemId, (response) => {
      this._onDataChange(response);
    });
  }

  _onDeleteButtonClickHandler(itemId) {
    setReduceCart(itemId, (response) => {
      this._onDataChange(response);
    });
  }

  _onOptionChangeHandler(itemId, optionId, action) {
    setOptionCart(itemId, optionId, action, (response) => {
      this._onDataChange(response);
    });
  }

  _onExpandOptionsButtonClickHandler(itemId, isShow) {
    // if (isShow) {
    //   this._openedOptions.push(itemId);
    //   return;
    // }

    // const index = this._openedOptions.findIndex((it) => it === itemId);

    // if (index === -1) {
    //   return;
    // }

    // this._openedOptions = [].concat(this._openedOptions.slice(0, index), this._openedOptions.slice(index + 1));
  }

  _onExpandGiftsButtonClickHandler(itemId, isShow) {
    // <p class="cart-page__giftsTitle">${gifts.title}</p>

  }
}
